webpackJsonp([269829036549620],{

/***/ 85:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/iStock_000039752072_Full.e31ea0fe.jpg";

/***/ }),

/***/ 504:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(34);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactMarkdown = __webpack_require__(47);
	
	var _reactMarkdown2 = _interopRequireDefault(_reactMarkdown);
	
	var _reactHelmet = __webpack_require__(41);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _core = __webpack_require__(22);
	
	var _styled = __webpack_require__(24);
	
	var _styled2 = _interopRequireDefault(_styled);
	
	var _Section = __webpack_require__(38);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Page = __webpack_require__(71);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _PaperContainer = __webpack_require__(72);
	
	var _PaperContainer2 = _interopRequireDefault(_PaperContainer);
	
	var _iStock_000039752072_Full = __webpack_require__(85);
	
	var _iStock_000039752072_Full2 = _interopRequireDefault(_iStock_000039752072_Full);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var content = _react2.default.createElement(
	  'div',
	  null,
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    null,
	    'Home Care Plus offers a wide variety of care options to individuals or couples. Our home care services are flexible and customized to meet your changing needs.'
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Numerous Benefits' },
	    _react2.default.createElement(
	      'ul',
	      { style: { margin: '0 0 0 20px', padding: 0 } },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Friendly companionship'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Mobility assistance'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Cooking and meal preparation'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Bathing, dressing and toileting'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Light housekeeping'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Errands and shopping'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Medication reminders'
	      )
	    )
	  ),
	  _react2.default.createElement(
	    _PaperContainer2.default,
	    { headerText: 'Arrangement of appointments' },
	    _react2.default.createElement(
	      'ul',
	      { style: { margin: '0 0 0 20px', padding: 0 } },
	      _react2.default.createElement(
	        'li',
	        null,
	        'Transportation to church or synagogue, appointments'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Social events'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Hospital concierge service'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Assistance with pet care'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'Airline departure/arrival assistance'
	      )
	    )
	  )
	);
	
	var Services = function Services(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    _Section2.default,
	    null,
	    _react2.default.createElement(
	      _core.Grid,
	      { item: true, xs: 12, sm: 8 },
	      _react2.default.createElement(_reactHelmet2.default, { title: 'Services - Home Care Plus' }),
	      _react2.default.createElement(
	        _Page2.default,
	        {
	          image: _iStock_000039752072_Full2.default,
	          title: "Services"
	        },
	        content
	      )
	    )
	  );
	};
	exports.default = Services;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-services-js-62a775cbc6d61266771a.js